import { PersonNotesPopoverServer } from '@/components/ProjectNotesPopover/PersonNotesPopoverServer';

interface ReaderNotesPopoverProps {
  open: boolean;
  anchorEl: HTMLElement | null;
  readerId: string;
  readerName: string;
  onClose: () => void;
}

/** Заметки чтеца — тот же UI и поведение, что у ProjectNotesPopover (персона). */
export function ReaderNotesPopover({ open, anchorEl, readerId, readerName, onClose }: ReaderNotesPopoverProps) {
  return (
    <PersonNotesPopoverServer
      open={open}
      onClose={onClose}
      anchorEl={anchorEl}
      personId={readerId}
      titleName={readerName}
    />
  );
}
